import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 44, x = 0, className = "", once = true }) => (
  <motion.div
    initial={{ opacity: 0, y, x }}
    whileInView={{ opacity: 1, y: 0, x: 0 }}
    viewport={{ once, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Logo = ({ compact = false }) => (
  <span className="inline-flex items-center gap-3" data-testid="nav-logo">
    <svg viewBox="0 0 64 64" className="h-9 w-9 shrink-0">
      <rect width="64" height="64" rx="14" fill="#111723" stroke="#F59E0B" strokeOpacity="0.35" />
      <path d="M10 46 L25 18 L33 32 L39 24 L54 46 Z" fill="none" stroke="#F59E0B" strokeWidth="3.5" strokeLinejoin="round" />
      <circle cx="47" cy="16" r="4" fill="#38BDF8" />
    </svg>
    {!compact && (
      <span className="leading-none">
        <span className="font-display block text-lg tracking-[0.14em] text-slate-50">GIACOMO BERTAGNOLLI</span>
        <span className="block text-[10px] uppercase tracking-[0.32em] text-amber-400">Sci Alpino Paralimpico</span>
      </span>
    )}
  </span>
);
